'use client';

import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import type { InternalNetworkCredentialVerificationBlockReason } from './internal-credential-verification-readiness.model';

const BLOCK_REASON_LABEL_KEYS = {
  no_enrollment: 'noTunnelEnrollment',
  sensor_not_online: 'sensorNotOnline',
  sensor_not_bound: 'sensorNotBound',
  sensor_binding_stale: 'sensorBindingStale',
  remote_c2_not_provisioned: 'remoteC2NotProvisioned',
  c2_paused: 'c2Paused',
  no_tunnel_enrollment: 'noTunnelEnrollment',
  tunnel_not_online: 'tunnelNotOnline',
  tunnel_routes_not_approved: 'tunnelRoutesNotApproved',
} as const satisfies Record<
  InternalNetworkCredentialVerificationBlockReason,
  string
>;

export const useInternalNetworkCredentialBlockReasonLabel = () => {
  const t = useTranslations(
    'designSystem.networkSettings.internalCredentials.prerequisites',
  );

  return useCallback(
    (
      reason: InternalNetworkCredentialVerificationBlockReason | null,
    ): string | null => (reason ? t(BLOCK_REASON_LABEL_KEYS[reason]) : null),
    [t],
  );
};
